'use client';

import { useState } from 'react';
import HeroSection from './HeroSection';
import ServiceTermsSection from './ServiceTermsSection';
import UserObligationsSection from './UserObligationsSection';
import LiabilityTermsSection from './LiabilityTermsSection';
import IntellectualPropertySection from './IntellectualPropertySection';
import ForceMajeureSection from './ForceMajeureSection';
import LegalComplianceSection from './LegalComplianceSection';
import AcceptanceSection from './AcceptanceSection';

export default function TermsAndConditionsInteractive() {
  const [expandedSection, setExpandedSection] = useState<string | null>(null);

  const toggleSection = (sectionId: string) => {
    setExpandedSection(expandedSection === sectionId ? null : sectionId);
  };

  return (
    <div className="min-h-screen">
      <HeroSection />
      <ServiceTermsSection 
        isExpanded={expandedSection === 'service-terms'}
        onToggle={() => toggleSection('service-terms')}
      />
      <UserObligationsSection 
        isExpanded={expandedSection === 'user-obligations'}
        onToggle={() => toggleSection('user-obligations')}
      />
      <LiabilityTermsSection 
        isExpanded={expandedSection === 'liability-terms'}
        onToggle={() => toggleSection('liability-terms')}
      />
      <IntellectualPropertySection 
        isExpanded={expandedSection === 'intellectual-property'}
        onToggle={() => toggleSection('intellectual-property')}
      />
      <ForceMajeureSection 
        isExpanded={expandedSection === 'force-majeure'}
        onToggle={() => toggleSection('force-majeure')}
      />
      <LegalComplianceSection 
        isExpanded={expandedSection === 'legal-compliance'}
        onToggle={() => toggleSection('legal-compliance')}
      />
      <AcceptanceSection />
    </div>
  );
}